import superagentWithRetries from './superagentWithRetries'


const WWW_REQUEST_RETRY_COUNT = 5
const WWW_REQUEST_RETRY_DELAY = 2000

export default superagentWithRetries(WWW_REQUEST_RETRY_COUNT, WWW_REQUEST_RETRY_DELAY)
